
import { Component, Prop, Emit, Mixins } from "vue-property-decorator"
import { ID, SpecialFeature } from "types/index"
import api from "../../honcierge-api"
import ProcessingMixin from "../../mixins/processing-mixin"

import { DataTableHeader } from "vuetify/types"

@Component
export default class SelectedSpecialFeaturesDialog extends Mixins(
  ProcessingMixin
) {
  private candidateSpecialFeatureMap: Map<ID, SpecialFeature["view"]> =
    new Map()

  @Prop()
  private dialog!: boolean
  @Prop()
  private selectedSpecialFeatures!: SpecialFeature["view"][]

  private specialFeatures: SpecialFeature["view"][] = []
  private pagination = {
    sortBy: ["priority"],
    sortDesc: [true],
  }

  get headers(): DataTableHeader[] {
    return [
      { text: "選択", value: "select", sortable: false },
      { text: "優先度", value: "priority" },
      { text: "タイトル", value: "title" },
      { text: "概要", value: "overview" },
      { text: "バナー", value: "banner", sortable: false },
    ]
  }

  @Emit("ok")
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public ok(selectedSpecialFeatures: []): void {
    /** */
  }

  @Emit("cancel")
  public cancel(): void {
    this.clear()
  }

  private searchResult(result: SpecialFeature["view"][]) {
    this.specialFeatures = result
    this.modifySelection()
  }

  private modifySelection() {
    this.specialFeatures.forEach((specialFeature) => {
      Object.assign(specialFeature, {
        select: this.candidateSpecialFeatureMap.has(specialFeature.priority),
      })
    })
  }

  private toggleCandidate(specialFeature: SpecialFeature["view"]) {
    if (specialFeature.select) {
      this.candidateSpecialFeatureMap.set(
        specialFeature.priority,
        specialFeature
      )
    } else {
      this.candidateSpecialFeatureMap.delete(specialFeature.priority)
    }
  }

  public async search() {
    const showOnTop = null
    const showTitle = null
    const isEnabled = null // カテゴリーとの紐付けにはフィルタリングしない。フィルタリングはAPI側(`GET /top`, `GET /special_features/{urlKey}`)で行う

    const page = 1
    const per = 10000000
    const sortBy = "priority"
    const descending = true
    const excludeSpecialFeatureIds = this.selectedSpecialFeatures.map(
      (feature) => feature.id
    )
    const includes = ["priority", "title", "overview", "id"]

    this.startProcess()
    try {
      const response = await api.getSpecialFeatures({
        showOnTop,
        isEnabled,
        showTitle,
        page,
        per,
        sortBy,
        descending,
        excludeSpecialFeatureIds,
        includes,
      })
      const result = response.data.specialFeatures
      this.searchResult(result.length > 0 ? result : [])
    } catch {
      this.$toasted.error("特集の取得に失敗しました")
    } finally {
      this.endProcess()
    }
  }

  private selected() {
    return Array.from(this.candidateSpecialFeatureMap.values())
  }

  public clear() {
    this.specialFeatures.length = 0
    this.specialFeatures = []

    this.candidateSpecialFeatureMap.clear()
  }

  private existBanner(banner: { filename: string; url: string }): boolean {
    return banner.filename !== null && banner.url !== null
  }
}
